<template>
  <v-app class="bgLightGreen boiler-page" id="inspire">
    <Header back header-text="lng_backup"></Header>
    <flash-message
      v-if="alertToggle"
      :message-data="flashMessageData"
      :alert-toggle="alertToggle"
      :do-translation="false"
      @alertToggleUpdate="flashMessageTimeOut()"
    ></flash-message>
    <v-container fluid>
      <v-layout row wrap justify-center>
        <v-flex xs12 md12 class="px-4 panel-block">
          <!-- <sub-menu
            v-if="userMenu.menu.submenu && userMenuData"
            :sub-menu="userMenu.menu.submenu"
            :sub-menu-data="userMenuData"
            :sub-menu-select-data="userMenu.menu.fieldsets.fieldset"
            :response-alert="setResponseAlert"
            :sub-menu-output-setting="filteredOutputSettings"
          ></sub-menu>-->
          <div class="fieldset mt-4">
            <legend class="md-whiteframe-z2" align="center">
              {{ "lng_app_backup" | translate }}
            </legend>
            <v-flex v-if="backupData">
              <div class="table-container" v-if="backupData.list">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="saveBackupData">
                      {{ "lng_backup_label" | translate }}
                    </v-btn>
                  </template>
                  <span>{{ "lng_tip_force_backup" | translate }}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="getTechAccess">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" @click="changeControllerDialog = true">
                      {{ "lng_change_controller_label" | translate }}
                    </v-btn>
                  </template>
                  <span>{{ "lng_tip_change" | translate }}</span>
                </v-tooltip>
                <span v-if="loadingBackup">
                  <v-progress-circular
                    class="mx-2"
                    :size="20"
                    :width="2"
                    color="#455a64"
                    indeterminate
                  ></v-progress-circular>
                  {{ "lng_backup_start" | translate }}
                </span>
                <div style="overflow-x: auto; ">
                  <table class="flex-table">
                    <thead>
                      <tr>
                        <th class="fixed"></th>
                        <th>
                          <span>Name</span>
                        </th>
                        <th>
                          <span>Created</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in paginatedData"
                        :key="item.id + index"
                      >
                        <td>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                text
                                icon
                                color="transparent"
                                v-on="on"
                                @click="pushSettings(item)"
                              >
                                <v-icon color="rgb(84,110,122)"
                                  >fast_forward</v-icon
                                >
                              </v-btn>
                            </template>
                            <span>{{ "lng_tip_push" | translate }}</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                text
                                icon
                                color="transparent"
                                v-on="on"
                                @click="deleteSettings(item)"
                              >
                                <!-- <v-icon>trash-can-outline</v-icon> -->
                                <v-icon color="rgb(84,110,122)">delete</v-icon>
                              </v-btn>
                            </template>
                            <span>{{
                              "lng_tip_force_delete" | translate
                            }}</span>
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                text
                                icon
                                color="transparent"
                                v-on="on"
                                @click="showEditFields(item)"
                              >
                                <!-- <v-icon>square-edit-outline</v-icon> -->
                                <v-icon color="rgb(84,110,122)">edit</v-icon>
                              </v-btn>
                            </template>
                            <span>{{
                              "lng_tip_force_rename" | translate
                            }}</span>
                          </v-tooltip>

                          <span>
                            <!-- <i
                            class="fa fa-spinner fa-pulse"
                            ng-if="item.progress > 0 && item.progress <= 99"
                            ></i>-->
                          </span>
                        </td>

                        <td>
                          <div
                            class="backup-action-btn"
                            v-if="showFields && selectedItem.id === item.id"
                          >
                            <v-text-field
                              placeholder="Placeholder"
                              solo
                              flat
                              autofocus
                              v-model="updatedName"
                            ></v-text-field>
                            <v-btn
                              color="#337ab7"
                              class="white--text"
                              fab
                              depressed
                              small
                              @click="editFieldData"
                            >
                              <v-icon dark>done</v-icon>
                            </v-btn>
                            <v-btn
                              color="#fff"
                              fab
                              depressed
                              small
                              @click="showFields = false"
                            >
                              <v-icon>clear</v-icon>
                            </v-btn>
                          </div>
                          <span v-else>{{ parseName(item.name) }}</span>
                        </td>

                        <td>{{ item.date }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="padinate-container">
                <div class="buttons">
                  <span class="label">
                    {{ paginatedItemsNumber }} of
                    {{ backupData.list.length }}
                  </span>
                  <v-btn text icon color="transparent">
                    <v-icon
                      color="rgb(84,110,122)"
                      :disabled="pageNumber === 0"
                      @click="prevPage"
                      >keyboard_arrow_left</v-icon
                    >
                  </v-btn>
                  <v-btn
                    text
                    icon
                    color="transparent"
                    :disabled="pageNumber >= pageCount - 1"
                    @click="nextPage"
                  >
                    <v-icon color="rgb(84,110,122)"
                      >keyboard_arrow_right</v-icon
                    >
                  </v-btn>
                </div>
              </div>
            </v-flex>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <refresh-timer
      v-if="showTimer"
      :refresh-time="pageRefreshTime"
      :refresh-page="refreshPage"
      :show-count-down="true"
      :key="timerKey"
    ></refresh-timer>
    <push-settings
      :open-dialog="pushSettingDialog"
      :close-dialog="closePushSettingDialog"
      :give-access="savePushSettings"
      message-text="lng_push_confirm_message"
      :translate="true"
      messageTitle="lng_push_confirm_title"
    />
    <delete-settings
      :open-dialog="deleteSettingDialog"
      :close-dialog="closeDeleteSettingDialog"
      :give-access="saveDeleteSettings"
      message-text="lng_delete_confirm_message"
      :translate="true"
      messageTitle="lng_delete_confirm_title"
    />
    <change-controller
      :open-dialog="changeControllerDialog"
      :close-dialog="closeControllerDialog"
      @save-controller="saveController($event)"
    />
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import RefreshTimer from "../components/RefreshTimer";
import GlobalService from "../services/global-service";
import FlashMessage from "../components/FlashMessage";
import TechAccessDialog from "../components/TechAccessDialog";
import ChangeController from "../components/ChangeController";
import { translate } from "../common/HelperFunctions";

export default {
  components: {
    Header,
    RefreshTimer,
    FlashMessage,
    pushSettings: TechAccessDialog,
    deleteSettings: TechAccessDialog,
    ChangeController
  },
  data: () => ({
    backupData: undefined,
    alertToggle: false,
    flashMessageData: {},
    responseObj: {},
    pageRefreshTime: 30,
    timerKey: 0,
    showTimer: false,
    pageNumber: 0,
    size: 10,
    pushSettingDialog: false,
    deleteSettingDialog: false,
    selectedItem: undefined,
    showFields: false,
    updatedName: "",
    loadingBackup: false,
    changeControllerDialog: false
  }),
  async created() {
    // start page loading component
    this.$store.commit("global/setLoading", true);
    await this.FetchApisData();
  },
  mounted() {
    document.getElementsByTagName("html")[0].className = "";
  },
  computed: {
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("global", ["getTechAccess"]),
    pageCount() {
      let l = this.backupData.list.length,
        s = this.size;
      return Math.ceil(l / s);
    },
    paginatedData() {
      const start = this.pageNumber * this.size,
        end = start + this.size;
      return this.backupData.list.slice(start, end);
    },
    paginatedItemsNumber() {
      let calNum = this.pageNumber * this.size;
      let num =
        calNum + this.size > this.backupData.list.length
          ? this.backupData.list.length
          : calNum + this.size;
      return `${calNum + 1} - ${num}`;
    }
  },
  methods: {
    async FetchApisData() {
      this.backupData = await GlobalService.getConfigbackupData(
        "list",
        this.getUser.token
      );
      this.backupData.list.sort(function(a, b) {
        return new Date(b.date) - new Date(a.date);
      });
      // this.showTimer = true;
      this.$store.commit("global/setLoading", false);
    },
    // to show the resposne alert on update field
    setResponseAlert(resObj) {
      this.alertToggle = true;
      this.responseObj = resObj;
      this.flashMessageData = {
        messageText: resObj.onlineandsaved
          ? `${translate("lng_save_ok")}`
          : `${translate("lng_save_notok")}`,
        showRegisterButton: false,
        color: resObj.onlineandsaved ? "rgba(76, 175, 80, 0.9)" : "red"
      };
      if (resObj.secs_to_next_update > 0) {
        this.pageRefreshTime = resObj.secs_to_next_update;
      }
      this.timerKey += 1;
    },
    flashMessageTimeOut() {
      this.alertToggle = false;
      this.responseObj = {};
    },
    // a funtion to refresh the page after specific time
    async refreshPage() {
      await this.FetchApisData();
      this.pageRefreshTime = 30;
      this.timerKey += 1;
    },
    nextPage() {
      this.pageNumber++;
    },
    prevPage() {
      this.pageNumber--;
    },
    parseName(name) {
      if (name === "") {
        return translate("lng_default_backup_name");
      } else if (name === "*manual") {
        return translate("lng_default_manual_backup_name");
      } else {
        return name;
      }
    },
    closePushSettingDialog() {
      this.pushSettingDialog = false;
    },
    pushSettings(item) {
      this.selectedItem = item;
      this.pushSettingDialog = true;
    },
    async savePushSettings() {
      this.closePushSettingDialog();
      let pushData = await GlobalService.pushConfigbackupData(
        "push",
        this.selectedItem.id,
        this.getUser.token
      );
      this.setResponseAlert(pushData);
    },
    closeDeleteSettingDialog() {
      this.deleteSettingDialog = false;
    },
    deleteSettings(item) {
      this.selectedItem = item;
      this.deleteSettingDialog = true;
    },
    async saveDeleteSettings() {
      this.closeDeleteSettingDialog();
      let pushData = await GlobalService.pushConfigbackupData(
        "delete",
        this.selectedItem.id,
        this.getUser.token
      );
      this.setResponseAlert(pushData);
    },
    showEditFields(item) {
      this.updatedName = item.name;
      this.selectedItem = item;
      this.showFields = true;
    },
    async editFieldData() {
      let pushData = await GlobalService.editConfigbackupData(
        "name",
        this.selectedItem.id,
        this.updatedName,
        this.getUser.token
      );
      this.setResponseAlert(pushData);
      this.updatedName = "";
      this.showFields = false;
      await this.FetchApisData();
    },
    async saveBackupData() {
      let pushData = await GlobalService.getConfigbackupData(
        "requestbackup",
        this.getUser.token
      );
      this.loadingBackup = true;
      this.setResponseAlert(pushData);
      setTimeout(() => {
        this.loadingBackup = false;
      }, 5000);
    },
    closeControllerDialog() {
      this.changeControllerDialog = false;
    },
    async saveController(data) {
      let resp = await GlobalService.handoverController(
        "handover",
        data.password,
        data.serial,
        this.getUser.token,
        data.radio
      );
      this.closeControllerDialog();
      // this.setResponseAlert(resp);
      this.alertToggle = true;
      this.responseObj = resp;
      this.flashMessageData = {
        messageText: `${translate("lng_save_ok")}`,
        showRegisterButton: false,
        color: "rgba(76, 175, 80, 0.9)"
      };
      if (resp.secs_to_next_update > 0) {
        this.pageRefreshTime = resp.secs_to_next_update;
      }
      this.timerKey += 1;
    }
  }
};
</script>

<style>
.backup-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px 0 0;
}
.backup-action-btn button {
  margin: 0 10px 0 0;
}
.backup-action-btn .v-text-field.v-text-field--solo .v-input__control {
  min-height: 40px;
  padding: 0;
  margin-right: 10px;
  width: 50px;
}
.backup-action-btn .v-text-field__details {
  display: none;
}
.table-container {
  display: block;
  max-width: 100%;
  overflow-x: auto;
}
.flex-table {
  flex: 1;
  box-sizing: border-box;
  width: 100%;
  border-spacing: 0;
  /* overflow: hidden;
  min-width: 662px; */
}
.flex-table tr {
  height: 56px;
}
.flex-table .fixed {
  padding: 0 24px;
  min-width: 128px;
}
.flex-table th {
  vertical-align: middle;
  text-align: left;
  color: rgba(0, 0, 0, 0.54);
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.flex-table th span {
  vertical-align: middle;
}
.flex-table tbody tr {
  height: 48px;
}
.flex-table tbody tr td {
  border-top: 1px rgba(0, 0, 0, 0.12) solid;
}
.padinate-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap-reverse;
  box-sizing: border-box;
  padding: 0 24px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
  border-top: 1px rgba(0, 0, 0, 0.12) solid;
  -webkit-font-smoothing: antialiased;
}
.md-table-pagination > .buttons {
  margin-right: -16px;
}
.md-table-pagination.buttons.label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}
.buttons {
  display: flex;
  align-items: center;
}
@media (max-width: 600px) {
  .boiler-page .v-btn--icon {
    display: block;
  }
  .flex-table .fixed {
    min-width: 50px;
  }
  .backup-action-btn .v-text-field.v-text-field--solo .v-input__control {
    width: 172px;
  }
}
</style>
